// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow() {
    return {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:last-of-type': {
                        '& .MuiTableCell-root': {
                            borderBottom: 'none'
                        }
                    },
                    '& .MuiTableCell-root': {
                        '&:last-of-type': {
                            paddingRight: 24,
                            '@media (max-width: 500px)': {
                                padding: 10,
                                textAlign: 'center',
                            }
                        },
                        '&:first-of-type': {
                            paddingLeft: 24,
                            '@media (max-width: 500px)': {
                                padding: 10,
                                textAlign: 'center',
                            }
                        }
                    }
                },
               /* '& .MuiTableRow-root': {
                    backgroundColor: 'red'
                    /!*'&:hover': {

                    }*!/
                }*/
            }
        }
    };
}
